import React from "react";
import { renderLayout } from "schema/ThemeSet.react";
import ParaBlock from "slides/components/ParaBlock.react";

export default class ImageStory extends React.Component {
    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);
        let modData = Object.assign({}, this.props.data, {
            question: this.props.data.title,
            paragraph: this.props.data.caption,
        });
        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    data={modData}
                    background={this.props.data.background}
                    mainContent={<ParaBlock {...this.props} data={modData} />}
                />
            </div>
        );
    }
}
